/**
 * Defines the small, stable set of counters displayed on the internal home page.
 */

export interface DashboardSummary {
  readonly closedCases: number;
  readonly openCases: number;
  readonly pendingCases: number;
}

/**
 * Treats only the CLOSED catalog value as closed. Pending assignment remains a subset of open cases.
 */
export function CalculateDashboardSummary(
  totalCases: number,
  pendingCases: number,
  closedCases: number,
): DashboardSummary {
  const normalizedClosedCases = Math.min(Math.max(closedCases, 0), Math.max(totalCases, 0));

  return Object.freeze({
    closedCases: normalizedClosedCases,
    openCases: Math.max(totalCases - normalizedClosedCases, 0),
    pendingCases: Math.max(pendingCases, 0),
  });
}
